export const GET_LISTS = "get_lists";
export const REFRESH_LISTS = "refresh_lists";
export const GET_LISTS_FAIL = "get_lists_fail";
export const GET_LISTS_SUCCESS = "get_lists_success";

export const CREATE_LIST = "create_list";
export const CREATE_LIST_FAIL = "create_list_fail";
export const CREATE_LIST_SUCCESS = "create_list_success";

export const UPDATE_LIST = "update_list";
export const UPDATE_LIST_FAIL = "update_list_fail";
export const UPDATE_LIST_SUCCESS = "update_list_success";

export const REMOVE_LIST = "remove_list";
export const REMOVE_LIST_FAIL = "remove_list_fail";
export const REMOVE_LIST_SUCCESS = "remove_list_success";

export const SET_LIST_MODAL = "set_list_modal";
export const RESET_LIST_MODAL = "reset_list_modal";

export const UPDATE_LIST_SEARCH = "update_list_search";

export const UPDATE_USER_LIST_SETTINGS = "update_user_list_settings";
export const UPDATE_USER_LIST_SETTINGS_FAIL = "update_user_list_settings_fail";
export const UPDATE_USER_LIST_SETTINGS_SUCCESS =
  "update_user_list_settings_success";

export const LIST_COUNT = "list_count";
export const LIST_COUNT_FAIL = "list_count_fail";
export const LIST_COUNT_SUCCESS = "list_count_success";
export const BUILD_LIST = "build_list";
export const BUILD_LIST_FAIL = "build_list_fail";
export const BUILD_LIST_SUCCESS = "build_list_success";

export const SET_ACTIVE_LIST = "set_active_list";
export const GET_SINGLE_LIST_ITEM = "get_single_list_item";
export const GET_SINGLE_LIST_ITEM_SUCCESS = "get_single_list_item_success";
export const REFRESH_SINGLE_LIST_ITEM = "refresh_single_list_item";

export const EDIT_ACTIVE_LIST = "edit_active_list";
export const UPDATE_NEW_COLUMN_WIDTH = "update_new_column_width";
